import angular from 'angular';

angular
  .module('cxInvoicing')
  .controller('CodaDialogCtrl', [
    '$element',
    '$http',
    'flySvc',
    'dataCache',
    'close',
    'appUrls',
    'companyId',
    codaDialogCtrl,
  ]);

function codaDialogCtrl($element, $http, flySvc, dataCache, close, appUrls, companyId) {
  var vm = this;

  vm.cancel = function() {
    close(null, 500);
  };
}
